// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/src/plugins/copyPaste/copyPaste.css
// module id = 491
// module chunks = 0